export const en = {
  translation: {
    seo: {
      defaults: {
        siteName: 'Fati Caftan',
        description: 'Moroccan artisan atelier — caftans, takchitas, djellabas, made-to-measure and ready to wear. Traditional couture, hand embroidery, careful finishing.'
      },
      organization: {
        description: 'Traditional Moroccan couture atelier — caftans, takchitas, djellabas and ready-to-wear pieces, hand-tailored in Morocco.'
      },
      home: {
        title: 'Caftans & traditional Moroccan couture',
        description: 'Discover the Fati Caftan collection: caftans, takchitas and djellabas hand-tailored in Morocco. Made-to-measure or ready to wear, book your appointment online.'
      },
      productDetail: {
        title: 'Piece details',
        description: 'Artisan piece from Fati Caftan — hand-tailored with traditional embroidery. Reserve via WhatsApp or book a fitting appointment.'
      },
      about: {
        title: 'About the atelier',
        description: 'The story and craft of the Fati Caftan atelier, dedicated to traditional Moroccan couture.'
      },
      contact: {
        title: 'Contact',
        description: 'Reach the Fati Caftan atelier by email, phone or WhatsApp for any question about pieces, appointments or reservations.'
      },
      faq: {
        title: 'Frequently asked questions',
        description: 'Everything you need to know before ordering a made-to-measure piece or reserving a ready-to-wear caftan at Fati Caftan.'
      },
      terms: {
        title: 'Terms',
        description: 'General terms applying to the use of the Fati Caftan website.'
      },
      legal: {
        title: 'Legal notice',
        description: 'Legal notice of the Fati Caftan website — publisher, host, intellectual property and contact.'
      },
      cgv: {
        title: 'Service terms',
        description: 'Appointment and reservation terms for pieces from the Fati Caftan atelier.'
      },
      privacy: {
        title: 'Privacy policy',
        description: 'Personal data protection on Fati Caftan — compliant with Moroccan law 09-08 and EU GDPR.'
      },
      notFound: {
        title: 'Page not found',
        description: 'The requested page does not exist or has been moved.'
      },
      underConstruction: {
        title: 'Coming soon',
        description: 'Fati Caftan is finalising its online boutique. Reach out on WhatsApp to learn more.'
      }
    },
    header: {
      title: 'Custom Tailoring',
      languages: {
        en: 'English',
        fr: 'French',
        ar: 'Arabic'
      }
    },
    underConstruction: {
      kicker: 'Atelier · Morocco',
      badge: 'Launching soon',
      title: {
        line1: 'Last stitches',
        line2: 'in progress.'
      },
      subtitle: 'Our atelier is finalising its online boutique. Caftans, takchitas, djellabas and ready-to-wear pieces — hand-tailored in Morocco. Reach out on WhatsApp today to book a consultation or hear more.',
      contactCta: 'Contact us on WhatsApp',
      contactHint: 'Reply within 24 h.',
      expected: {
        label: 'Orders',
        value: 'Already open on WhatsApp'
      },
      workshop: {
        label: 'The atelier',
        value: 'One-of-a-kind hand-sewn pieces, traditional embroidery, made-to-measure or ready-to-wear.'
      },
      footer: '© {{year}} Fati Caftan — all rights reserved.',
      whatsapp: {
        message: 'Hello, I came from your site faticaftan.com — I\'d love to hear more about your pieces.'
      }
    },
    nav: {
      home: 'Home',
      dashboard: 'Dashboard',
      appointments: 'Appointments',
      calendar: 'Calendar',
      products: 'Products',
      analytics: 'Audience',
      cart: 'Cart',
      login: 'Login',
      logout: 'Logout',
      openMenu: 'Open menu',
      closeMenu: 'Close menu'
    },
    adminAnalytics: {
      title: 'Audience',
      subtitle: 'Site traffic, measured from the server logs. No tracking script, no cookie.',
      loading: 'Loading figures…',
      visitors: 'Unique visitors',
      pageViews: 'Page views',
      period: 'Period',
      dailyRefresh: 'Refreshed once a day',
      daily: 'Visits per day',
      dailyChartLabel: 'Chart of visits per day',
      noDaily: 'No daily series yet.',
      topPages: 'Most viewed pages',
      referrers: 'Referrers',
      countries: 'Countries',
      noData: 'No data.',
      noCountries: 'Country database missing — re-run the script with ACTION=geoip.',
      unavailableMock: 'Figures unavailable in demo mode: there is no real data to show.',
      botNote: 'Declared bots, uptime monitoring and scanner probes are excluded. Some automated traffic remains on the home page.'
    },
    calendar: {
      title: 'Calendar',
      subtitle: 'Month view of all appointments.',
      prev: 'Previous month',
      next: 'Next month',
      today: 'Today',
      more: 'more'
    },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Overview of bookings and catalog activity.',
      viewAll: 'View all',
      stats: {
        pending: 'Pending',
        confirmed: 'Confirmed',
        completed: 'Completed',
        cancelled: 'Cancelled',
        products: 'Products'
      },
      upcoming: {
        title: 'Upcoming (next 7 days)',
        empty: 'No appointments in the coming week.'
      },
      recent: {
        title: 'Recent requests',
        empty: 'No appointment requests yet.'
      }
    },
    confirm: {
      confirm: 'Confirm',
      cancel: 'Cancel'
    },
    login: {
      title: 'Admin Login',
      email: 'Email',
      password: 'Password',
      submit: 'Sign in',
      submitting: 'Signing in…',
      mockHint: {
        title: 'Mock credentials (dev only)'
      }
    },
    hero: {
      title: 'Custom Tailored Excellence',
      subtitle: 'Schedule your professional measurement appointment today. Our expert tailors ensure perfect fit and exceptional quality for your custom garments.',
      kicker: 'House of Couture — Morocco',
      titleLine1: 'Night as the',
      titleAccent1: 'setting',
      titleLine2: ', the caftan',
      titleLine3: 'as your',
      titleAccent2: 'signature.',
      lede: 'Fifteen years of atelier in Morocco. Silk, brocade, gold-thread embroidery. Every piece exists in a single edition — yours, because we cut it after meeting you.',
      ctaPrimary: 'Book an appointment',
      ctaSecondary: 'Discover the collections',
      refNumber: 'N°00',
      refLabel: 'Inaugural number'
    },
    atelier: {
      kicker: 'N° 05 — The Atelier',
      titleLine1: 'One',
      titleAccent: 'maison',
      titleLine2: ', one signature.',
      body1: 'Fati learned to sew alongside her mother in a house in the medina of Fes, at an age when others were still playing. Fifteen years later she sketches every piece in brown ink on kraft paper, picks her fabrics at Bab Boujloud, and entrusts the embroidery to a small circle of artisans she knows by first name.',
      body2: 'Each caftan follows an eight-week minimum calendar. No stock, no mass production. Luxury, here, is the time we take for you.',
      stats: {
        yearsValue: '15',
        yearsLabel: 'Years atelier',
        piecesValue: '200+',
        piecesLabel: 'Pieces delivered',
        citiesValue: '2',
        citiesLabel: 'Casa · Marrakech'
      }
    },
    waStrip: {
      titleLine1: 'A',
      titleAccent: 'question',
      titleLine2: ', a custom order?',
      subtitle: 'Whatsapp the atelier — reply within 24 h, in French, Arabic, or English.',
      cta: 'Message the atelier'
    },
    share: {
      button: 'Share',
      copiedToast: 'Link copied',
      copyFailed: 'Could not copy the link.',
      instagramHint: 'Link copied — paste it in your Instagram story',
      targets: {
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        pinterest: 'Pinterest',
        instagram: 'Instagram (copy)',
        email: 'Email',
        copy: 'Copy link'
      }
    },
    story: {
      button: 'Instagram story format',
      generating: 'Generating…',
      success: 'Story image downloaded — post it to your story.',
      error: 'Could not generate the story image'
    },
    currency: {
      label: 'Currency',
      indicative: '≈ indicative price',
      codes: {
        MAD: 'Dirham (MAD)',
        EUR: 'Euro (EUR)',
        USD: 'Dollar (USD)'
      }
    },
    product: {
      duration: 'Measurement Duration',
      viewDetails: 'View Details',
      scheduleButton: 'Schedule Measurement Appointment',
      shopButton: 'Order',
      reserveButton: 'Reserve',
      readyToWearBadge: 'Ready to wear'
    },
    cart: {
      title: 'Your cart',
      itemCount: '{{count}} item(s) in cart',
      sizeLabel: 'Size',
      increase: 'Increase quantity',
      decrease: 'Decrease quantity',
      remove: 'Remove',
      checkoutCta: 'Go to checkout',
      continueShopping: 'Continue shopping',
      empty: {
        title: 'Your cart is empty',
        description: 'Browse our ready-to-wear collection and add pieces here.',
        cta: 'Browse catalog'
      },
      summary: {
        title: 'Summary',
        subtotal: 'Subtotal',
        shipping: 'Shipping',
        shippingHint: 'Confirmed on WhatsApp',
        total: 'Total'
      },
      toast: {
        added: 'Added to cart (size {{size}})'
      }
    },
    checkout: {
      title: 'Complete your order',
      subtitle: 'Your details will be sent to the seamstress via WhatsApp to confirm stock and arrange delivery.',
      backToCart: 'Back to cart',
      submitCta: 'Send via WhatsApp',
      success: 'Order sent — the seamstress will reply shortly.',
      disclaimer: 'Payment and delivery are arranged directly with the seamstress on WhatsApp.',
      fields: {
        fullName: 'Full name',
        phone: 'Phone',
        city: 'City',
        address: 'Delivery address',
        notes: 'Note (optional)'
      },
      errors: {
        required: 'Required',
        invalidPhone: 'Invalid number'
      },
      whatsapp: {
        header: 'Hello, I would like to place the following order:',
        itemsHeader: 'Items:',
        total: 'Total',
        footer: 'Please confirm stock availability and delivery options.'
      }
    },
    form: {
      title: 'Schedule Measurement Appointment',
      about: {
        title: 'About the Measurement Process',
        description: 'Our professional measurement service ensures perfect fit and customization. A skilled specialist will take detailed measurements using state-of-the-art tools.',
        duration: 'Duration'
      },
      fields: {
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone Number',
        date: 'Preferred Date',
        time: 'Preferred Time',
        notes: 'Special Requirements or Notes',
        notesPlaceholder: 'Any special requirements or additional information...'
      },
      timeSlots: {
        morning: 'Morning',
        afternoon: 'Afternoon',
        evening: 'Evening'
      },
      buttons: {
        cancel: 'Cancel',
        confirm: 'Confirm Appointment'
      },
      success: 'Appointment scheduled successfully! You will receive a confirmation email shortly.',
      errors: {
        nameTooShort: 'Please enter your full name (at least 2 characters).',
        emailInvalid: 'Please enter a valid email address.',
        phoneInvalid: 'Please enter a valid phone number.',
        dateRequired: 'Please pick a date.',
        timeRequired: 'Please choose a time slot.',
        slotConflict: 'This slot was just booked by someone else. Please choose another.'
      },
      slots: {
        fullyBooked: 'fully booked',
        taken: 'taken'
      }
    },
    catalog: {
      search: {
        label: 'Search catalog',
        placeholder: 'Search by name or description…'
      },
      category: {
        label: 'Category',
        values: {
          ALL: 'All',
          CAFTAN: 'Caftan',
          TAKCHITA: 'Takchita',
          DJELLABA: 'Djellaba',
          OTHER: 'Other'
        }
      },
      type: {
        label: 'Buying mode',
        values: {
          ALL: 'All',
          CUSTOM: 'Made to measure',
          READY_TO_WEAR: 'Ready to wear'
        }
      },
      minPrice: 'Min price',
      maxPrice: 'Max price',
      sort: {
        label: 'Sort by',
        relevance: 'Relevance',
        priceAsc: 'Price: low to high',
        priceDesc: 'Price: high to low',
        ratingDesc: 'Top rated'
      },
      clear: 'Clear',
      empty: 'No products match your filters.',
      count: '{{count}} of {{total}} products',
      sections: {
        emptyCategory: 'No pieces available in this category at the moment.',
        caftan: {
          num: '01',
          numLabel: 'Category',
          titleLine1: 'The',
          titleAccent: 'caftans',
          titleLine2: '.',
          subtitle: 'Custom pieces for brides and grand occasions.',
          countLabel: 'pieces · made to measure',
          metaLine1: 'Custom · 8 weeks',
          metaLine2: '3 fittings'
        },
        takchita: {
          num: '02',
          numLabel: 'Category',
          titleLine1: 'The',
          titleAccent: 'takchitas',
          titleLine2: '.',
          subtitle: 'Two pieces, two acts. For the grandest evenings.',
          countLabel: 'pieces · made to measure',
          metaLine1: 'Custom · 10 weeks',
          metaLine2: 'With gold belt'
        },
        djellaba: {
          num: '03',
          numLabel: 'Category',
          titleLine1: 'The',
          titleAccent: 'djellabas',
          titleLine2: '.',
          subtitle: 'Refined everyday wear, ready-made or hand-stitched.',
          countLabel: 'pieces · made to measure',
          metaLine1: 'Ready-to-wear · in stock',
          metaLine2: 'Custom · 4 weeks'
        },
        readyToWear: {
          num: '04',
          numLabel: 'Category',
          titleLine1: 'The',
          titleAccent: 'ready-to-wear',
          titleLine2: '.',
          subtitle: 'Pieces available immediately, sizes XS to XXL.',
          countLabel: 'pieces · stock',
          metaLine1: 'Delivery · 7 days',
          metaLine2: 'Exchange within 14 days'
        }
      },
      scrollPrev: 'Previous',
      scrollNext: 'Next'
    },
    whatsapp: {
      aria: 'Chat on WhatsApp',
      message: 'Hello, I would like to know more about your bespoke pieces.'
    },
    testimonials: {
      kicker: '— Testimonials',
      title: 'Atelier confidences',
      subtitle: 'What clients who have worn our pieces have to say.',
      items: {
        one: {
          name: 'Yasmine A.',
          city: 'Casablanca',
          quote: 'A perfect cut for my wedding. Every detail was hand-finished with rare patience.'
        },
        two: {
          name: 'Salma B.',
          city: 'Rabat',
          quote: 'The attention to detail won me over. My caftan fit like a second skin.'
        },
        three: {
          name: 'Nora E.',
          city: 'Marrakech',
          quote: 'Exceptional service, from first fitting to delivery. I recommend without hesitation.'
        },
        four: {
          name: 'Inès D.',
          city: 'Paris',
          quote: 'A truly unique piece for a wedding in Fez. The result exceeded my expectations.'
        }
      }
    },
    notFound: {
      kicker: 'Error · 404',
      titleLine1: 'This page',
      titleLine2: 'has gone astray.',
      subtitle: 'The link you followed may be outdated, or the piece you sought has left the atelier. Let us start from the beginning.',
      requestedPath: 'Requested path',
      backHome: 'Back to home',
      suggestions: {
        catalog: 'Browse the catalog',
        about: 'Discover the atelier',
        contact: 'Get in touch'
      }
    },
    productDetail: {
      back: 'Back to catalog',
      gallery: 'Gallery',
      thumbnailAlt: 'View {{n}} of {{title}}',
      from: 'From',
      rating: 'Rating',
      durationLabel: 'Measurement duration',
      detailsTitle: 'Piece details',
      reserveCta: 'Book my measurement appointment',
      sizeLabel: 'Size',
      addToCart: 'Add to cart',
      buyNow: 'Buy now',
      reserveOnWhatsApp: 'Reserve via WhatsApp',
      reserveOnWhatsAppHint: 'Direct chat — payment in person or by bank transfer.',
      reserveWhatsAppMessage: 'Hello, I would like to reserve "{{title}}" in size {{size}} ({{price}} MAD). Is it available?',
      outOfStock: 'Out of stock',
      notFound: 'Product not found.',
      loading: 'Loading…'
    },
    footer: {
      tagline: 'Bespoke garments, hand-tailored in Paris since 2014.',
      explore: 'Explore',
      contact: 'Contact',
      hours: 'Opening hours',
      weekdays: 'Mon – Fri: 10:00 – 19:00',
      saturday: 'Saturday: 11:00 – 18:00',
      sunday: 'Sunday: closed',
      rights: 'All rights reserved.',
      links: {
        about: 'About',
        contact: 'Contact',
        terms: 'Terms',
        cgv: 'Service terms',
        privacy: 'Privacy',
        legal: 'Legal notice',
        faq: 'FAQ'
      }
    },
    faq: {
      kicker: 'Frequently asked',
      titleLine1: 'Everything you need to know',
      titleLine2: 'before your appointment.',
      subtitle: 'Answers to the most common questions about our pieces, measurements and timelines.',
      cta: {
        lead: 'A question that isn\'t answered here?',
        button: 'Write to us'
      },
      items: {
        appointment: {
          question: 'How do I book a measurement appointment?',
          answer: 'Choose the piece you like in the catalog and click "Schedule appointment". Pick a date and time slot (morning, afternoon or evening). You will receive an email confirmation within 24 hours.'
        },
        measurement: {
          question: 'What happens during the measurement session?',
          answer: 'A skilled artisan takes about twenty precise measurements using professional tools. She will also advise you on fabrics, cuts and finishes suited to your shape and the occasion.'
        },
        duration: {
          question: 'How long until I receive my piece?',
          answer: 'Allow 4 to 6 weeks for a full caftan or takchita, 2 to 3 weeks for a djellaba or a simpler piece. For weddings, plan at least 8 weeks to include several fittings.'
        },
        fabric: {
          question: 'Can I choose my own fabric?',
          answer: 'Yes. We work with silks, muslins, brocades and woolens sourced from Moroccan and European suppliers. You may also bring your own fabric — we will advise on its suitability for the chosen model.'
        },
        fitting: {
          question: 'How many fittings are planned?',
          answer: 'Two intermediate fittings are included in the price, plus a final fitting at delivery. For complex pieces (a wedding caftan, for example), a third fitting can be added at no extra cost.'
        },
        alteration: {
          question: 'Are alterations included?',
          answer: 'All fit alterations are included during the first year. Beyond that, alterations remain available at a preferential rate for our clients.'
        },
        payment: {
          question: 'What payment methods do you accept?',
          answer: 'A 50% deposit secures the order at the end of the measurement session. The balance is paid on delivery. We accept card, bank transfer and cash.'
        },
        cancellation: {
          question: 'Can I cancel or reschedule my appointment?',
          answer: 'Free cancellation or rescheduling up to 24 hours before the appointment, via the link in your confirmation email. Beyond that, a new slot may be offered subject to availability.'
        },
        travel: {
          question: 'Do you travel to clients?',
          answer: 'For weddings and large orders (3 pieces and above), we travel at no extra charge within Casablanca, Rabat and Marrakech. Beyond these cities, travel fees may apply.'
        },
        delivery: {
          question: 'Do you ship internationally?',
          answer: 'Yes, we ship worldwide via insured carrier. Fees and delivery times depend on destination and will be confirmed at order placement.'
        }
      }
    },
    about: {
      title: 'About us',
      lead: 'A small Parisian workshop committed to bespoke craftsmanship.',
      body1: 'We have been hand-tailoring garments since 2014, working with carefully selected fabrics from Italian and English mills. Each piece is cut, sewn, and finished in our atelier — no outsourcing, no mass production.',
      body2: 'Whether for a wedding, a daily commute, or a milestone celebration, we measure each client in person and adapt every detail to their posture, gestures, and lifestyle.',
      valuesTitle: 'What we stand for',
      values: {
        craft: {
          title: 'Hand craftsmanship',
          body: 'Every seam, buttonhole, and lining is made by experienced tailors using traditional techniques.'
        },
        quality: {
          title: 'Material quality',
          body: 'We source from long-trusted weavers and refuse shortcuts that compromise drape or durability.'
        },
        service: {
          title: 'Personal service',
          body: 'Fewer clients, more attention. Every fitting is taken seriously and adjustments included for life.'
        }
      }
    },
    contact: {
      title: 'Contact',
      lead: 'Questions, custom requests, or wholesale enquiries — we read every message.',
      email: 'Email',
      phone: 'Phone',
      address: 'Atelier',
      fields: {
        name: 'Your name',
        email: 'Email',
        message: 'Message'
      },
      sending: 'Sending…',
      send: 'Send message',
      success: 'Thanks! We\'ll reply within one business day.'
    },
    terms: {
      title: 'Terms of service',
      updated: 'Last updated {{date}}',
      sections: {
        scope: {
          title: '1. Scope',
          body: 'These terms govern bookings made through our website and the bespoke service delivered in our Paris atelier.'
        },
        appointments: {
          title: '2. Appointments',
          body: 'Appointments are confirmed by email. Please arrive 5 minutes early and bring any reference garments you would like discussed.'
        },
        payment: {
          title: '3. Payment',
          body: 'A 50% deposit secures your bespoke order. The balance is due at delivery. We accept card and bank transfer.'
        },
        cancellation: {
          title: '4. Cancellation',
          body: 'Free cancellation up to 24 hours before the appointment. Bespoke orders, once cut, cannot be refunded — but adjustments are included for life.'
        },
        privacy: {
          title: '5. Privacy',
          body: 'We collect only the information needed to deliver the service. We do not share or sell your data. You may request deletion at any time.'
        },
        liability: {
          title: '6. Liability',
          body: 'We stand by our craftsmanship. If a defect appears within twelve months of delivery, we will repair or replace the item at no charge.'
        }
      }
    },
    admin: {
      title: 'Appointments',
      subtitle: 'Review and manage measurement appointment requests.',
      empty: 'No appointments match this filter.',
      confirmDelete: {
        title: 'Delete appointment?',
        message: 'This appointment will be permanently removed. This cannot be undone.'
      },
      toast: {
        statusUpdated: 'Appointment status updated.',
        deleted: 'Appointment deleted.'
      },
      filter: {
        all: 'All',
        pending: 'Pending',
        confirmed: 'Confirmed',
        completed: 'Completed',
        cancelled: 'Cancelled'
      },
      status: {
        pending: 'Pending',
        confirmed: 'Confirmed',
        completed: 'Completed',
        cancelled: 'Cancelled'
      },
      table: {
        client: 'Client',
        product: 'Product',
        date: 'Date',
        requested: 'Requested',
        status: 'Status',
        actions: 'Actions'
      },
      actions: {
        confirm: 'Confirm',
        complete: 'Mark completed',
        reopen: 'Reopen as pending',
        cancel: 'Cancel',
        delete: 'Delete'
      },
      search: {
        label: 'Search',
        placeholder: 'Search name, email, phone…',
        from: 'From',
        to: 'To',
        clear: 'Clear filters'
      },
      pagination: {
        showing: 'Showing {{from}}–{{to}} of {{total}}'
      },
      detail: {
        title: 'Appointment',
        client: 'Client',
        booking: 'Booking',
        notes: 'Notes',
        notesPlaceholder: 'Add internal notes…',
        saveNotes: 'Save notes',
        saving: 'Saving…',
        notesSaved: 'Notes saved.',
        timeline: 'Timeline',
        created: 'Created',
        updated: 'Last updated',
        actions: 'Actions'
      }
    },
    adminProducts: {
      title: 'Products',
      subtitle: 'Create, edit, and remove items from the public catalog.',
      new: 'New product',
      empty: 'No products yet. Create the first one.',
      i18n: {
        sourceLocaleLabel: 'Input language',
        sourceLocaleHint: 'Language of the title and description below (what you type).',
        locales: {
          ar: 'Arabic',
          fr: 'French',
          en: 'English'
        },
        translationsLabel: 'Translations',
        translationsHint: 'AI-generated from the source — review before saving.',
        translateButton: 'Translate (AI)',
        translating: 'Translating…',
        translated: 'Translated ({{count}} languages) — review before saving.',
        errors: {
          needSource: 'Enter the source title and description first.',
          empty: 'The translation service returned nothing. Try again, or fill the translations in by hand.'
        }
      },
      confirmDelete: {
        title: 'Delete product?',
        message: 'Delete "{{title}}"? This will hide it from the public catalog.'
      },
      toast: {
        created: 'Product created.',
        updated: 'Product updated.',
        deleted: 'Product deleted.'
      },
      table: {
        product: 'Product',
        price: 'Price',
        duration: 'Duration',
        rating: 'Rating',
        actions: 'Actions'
      },
      actions: {
        edit: 'Edit',
        delete: 'Delete'
      },
      fields: {
        title: 'Title',
        category: 'Category',
        productType: 'Buying mode',
        productTypeHint: 'Made to measure: appointment flow. Ready to wear: cart + delivery.',
        price: 'Price',
        originalPrice: 'Original price (optional)',
        description: 'Description',
        image: 'Image',
        imageUrl: 'Image URL',
        rating: 'Rating (0–5)',
        measurementDuration: 'Measurement duration'
      },
      variants: {
        label: 'Sizes & stock',
        sizeLabel: 'Size',
        stockLabel: 'Stock',
        stockSuffix: 'pcs',
        remove: 'Remove this size',
        hint: 'One row per size. Click a size to add it, then set the stock.',
        errors: {
          required: 'Add at least one size (ready-to-wear mode).',
          invalidRow: 'Check sizes and stock values (stock ≥ 0).'
        }
      },
      image: {
        dropOrClick: 'Drop an image or click to upload',
        hint: 'PNG, JPG or WEBP, max 10 MB. You can also paste a URL below.',
        urlPlaceholder: 'or paste an image URL…',
        sourceLabel: 'Source photo',
        sourceHint: 'The original photo the visuals were generated from. Not visible to customers.',
        regenerateFromSource: 'Regenerate from source',
        zoom: 'Enlarge image',
        zoomClose: 'Close preview',
        primaryHint: 'primary image (catalog card)',
        errors: {
          notImage: 'Selected file is not an image.',
          tooLarge: 'Image is too large (max 10 MB).',
          required: 'Please add an image (file or URL).'
        }
      },
      gallery: {
        label: 'Gallery',
        add: 'Add',
        remove: 'Remove',
        reorder: 'Drag to reorder',
        setAsPrimary: 'Set as primary image',
        imageAlt: 'Gallery image {{n}}',
        hint: 'Secondary images shown on the product detail page. Up to 8 images. Drag the handle to reorder — the first one acts as the gallery main image.',
        errors: {
          full: 'Gallery is full (max {{max}} images). Remove one to add another.'
        }
      },
      form: {
        newTitle: 'New product',
        editTitle: 'Edit product',
        cancel: 'Cancel',
        save: 'Save',
        saving: 'Saving…'
      },
      ai: {
        button: 'Enhance with AI',
        buttonHint: 'Generates 4 poses on a human model (~1 min, ~$0.16 per set).',
        title: 'Enhance photo with AI',
        intro: 'AI will replace the mannequin with a realistic human silhouette on a clean studio backdrop while preserving every embroidery detail of the garment.',
        introSet: 'AI will generate 4 different poses from the source photo. Keep the ones you like; reject or regenerate the others.',
        setHint1: 'Each pose highlights a different angle of the garment (front, seated, back, walking side).',
        setHint2: 'Cost: ~$0.16 for the 4-pose set, ~$0.04 per regeneration.',
        keptCount_zero: 'No pose kept',
        keptCount_one: '{{count}} pose kept',
        keptCount_other: '{{count}} poses kept',
        originalLabel: 'Original photo',
        transformedLabel: 'AI result',
        placeholder: 'Waiting…',
        startCta: 'Start transformation',
        startSetCta: 'Generate 4 poses',
        startNewSet: 'New set of 4',
        startSetCostHint: 'Generates 4 new poses (~$0.16). Images you already kept are not removed.',
        resuming: 'Loading existing poses…',
        finishCta_zero: 'Done',
        finishCta_one: 'Done ({{count}} pose)',
        finishCta_other: 'Done ({{count}} poses)',
        processing: 'Generating…',
        processingHint: 'Takes 15 to 30 seconds.',
        working: 'Working…',
        failed: 'Failed.',
        rejected: 'Rejected.',
        accept: 'Accept',
        keep: 'Keep',
        kept: 'Kept',
        keptBadge: 'Kept',
        reject: 'Reject',
        regenerate: 'Regenerate',
        regenerateCostHint: 'Regenerate costs ~$0.04.',
        promptEdit: 'Edit prompt',
        promptHide: 'Hide prompt',
        promptRegenerate: 'Regenerate with this prompt',
        promptReset: 'Reset',
        retry: 'Retry',
        cancel: 'Cancel',
        close: 'Close',
        poses: {
          STANDING_FRONT: 'Standing, front',
          SEATED: 'Seated',
          BACK_OVER_SHOULDER: 'Back / glance',
          WALKING_SIDE: 'Walking, side'
        },
        errors: {
          pollTimeout: 'Timed out — generation took too long. Try again or contact admin if the problem persists.'
        }
      }
    }
  }
};
